import {
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import LeftArrow from "./icon/LeftArrow";
import RightArrow from "./icon/RightArrow";

function PaginationComp({ pagi, setPagi, total }) {
  return (
    <Grid container>
      <Grid
        xs={12}
        item
        display="flex"
        alignItems="center"
        gap="6px"
        mt="12px"
        justifyContent="flex-end"
      >
        <Typography sx={{ fontSize: "12px" }}>Số hàng mỗi trang:</Typography>
        <FormControl size="small">
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={pagi?.limit ?? 50}
            onChange={(e) => setPagi({ ...pagi, limit: e.target.value })}
            size="small"
            sx={{
              fontSize: "12px",
              "&.MuiInputBase-root > div.MuiSelect-select": {
                p: "6px 30px 6px 14px !important",
              },
            }}
          >
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={200}>200</MenuItem>
          </Select>
        </FormControl>
        <Typography sx={{ fontSize: "12px" }}>
          {!!pagi?.skip ? pagi?.skip + 1 : 1}–
          {!!total ? Math.ceil(total / pagi?.limit) : 0} of{" "}
          {!!total ? Math.ceil(total / pagi?.limit) : 0}
        </Typography>
        <IconButton
          onClick={() => setPagi((prev) => ({ ...prev, skip: prev.skip - prev.limit }))}
          disabled={pagi?.skip === 0}
        >
          <LeftArrow />
        </IconButton>

        <IconButton
          onClick={() => setPagi((prev) => ({ ...prev, skip: prev.skip + prev.limit }))}
          disabled={total - (pagi?.skip ?? 0) <= (pagi?.limit ?? 0)}
        >
          <RightArrow />
        </IconButton>
      </Grid>
    </Grid>
  );
}
export default React.memo(PaginationComp);
